import { WorkflowTechCheckStage } from 'api-clients/monolith';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { makeUniversalRecruiterDashboardEnabled } from 'containers/Auth_old/selectors';
import { IdleMoveRule } from 'containers/WorkflowEditor/components/IdleMoveRule';
import { ReviewStage } from 'containers/WorkflowEditor/components/ReviewStage';
import { StageSection } from 'containers/WorkflowEditor/components/StageSection';
import { StageSettingMessageCard } from 'containers/WorkflowEditor/components/StageSettingMessageCard';

import { AdvancedSettings } from './AdvancedSettings';
import { CustomerSupport } from './CustomerSupport';
import { Requirements } from './Requirements';

export interface TechCheckStageProps {
  stage: WorkflowTechCheckStage;
}

export const TechCheckStage: FC<TechCheckStageProps> = ({ stage }) => {
  const universalRecruiterDashboardEnabled = useSelector(
    makeUniversalRecruiterDashboardEnabled(),
  );

  return (
    <div data-testid="techCheckStage">
      {universalRecruiterDashboardEnabled && (
        <StageSection>
          <ReviewStage stage={stage} />
        </StageSection>
      )}
      <StageSection>
        <Requirements stage={stage} />
      </StageSection>
      <StageSection>
        <CustomerSupport stage={stage} />
      </StageSection>
      <StageSection>
        <IdleMoveRule stage={stage} />
      </StageSection>
      <StageSection>
        <StageSettingMessageCard
          messageType="tech_check"
          stageExternalId={stage.external_id}
        />
      </StageSection>
      <StageSection>
        <StageSettingMessageCard
          messageType="trigger"
          stageExternalId={stage.external_id}
        />
      </StageSection>
      <StageSection>
        <AdvancedSettings stage={stage} />
      </StageSection>
    </div>
  );
};
